module.exports = __webpack_public_path__ + "static/media/es.1470e07d.svg";